import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HTTPRequestMethod } from '@app/core/enums/http-request-method.enum';
import { MimeType } from '@app/core/enums/mime-type.enum';
import { ApiSendRequestService } from '@services/api/api.send.request.service';
import { ClaimService } from '@services/claims/claims.service';
import { StorageService } from '@services/storage/storage.service';
import { UserAccessService } from '@services/user-access/user-access.service';
import { LoggerService } from '@services/logger/logger.service';
import { jwtDecode } from 'jwt-decode';
import { Observable, Subject } from 'rxjs';
import { take, timeout } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public onBehalfOf: string;
  public decodedUserIdToken: any;
  public userIdToken: string;
  private userTokenUpdatedSubject = new Subject<void>();
  private user: any;

  /* istanbul ignore next */
  private readonly userIdTokenKey = environment.production ? 'user-id-token' : 'user-id-token-dev';

  constructor(
    private apiSendRequestService: ApiSendRequestService,
    private claimService: ClaimService,
    private http: HttpClient,
    private loggerService: LoggerService,
    private router: Router,
    private storageService: StorageService,
    private userAccessService: UserAccessService,
  ) {
    this.user = this.userAccessService.getUser();
  }

  /* istanbul ignore next */
  public getUserTokenUpdatedObservable() {
    const tokenTimeout = 300000;

    return this.userTokenUpdatedSubject.asObservable().pipe(
      take(1),
      timeout(tokenTimeout),
    );
  }

  public async getUserIdToken() {
    if (!this.userIdToken) {
      this.userIdToken = (await this.storageService.getSession(this.userIdTokenKey));
    }

    return this.userIdToken;
  }

  public async storeUserIdToken(token: string) {
    this.userIdToken = token;
    this.decodedUserIdToken = jwtDecode(token);
    this.onBehalfOf = this.decodedUserIdToken.sub;
    this.userTokenUpdatedSubject.next();

    return this.storageService.setSession(this.userIdTokenKey, token);

  }

  /**
   * @param  {string} path
   * @param  {HTTPRequestMethod} requestMethod
   * @param  {MimeType} mimeType?
   * @param  {any} body?
   * @returns Observable
   */
  public sendRequest(path: string, requestMethod: HTTPRequestMethod, mimeType?: MimeType, body?: any, isCacheable?: any): Observable<any> {
    return this.apiSendRequestService.sendRequest(path, requestMethod, mimeType, body, isCacheable);
  }
}
